import React, { Component } from "react";
import "./AboutUsPage.scss";
import OptionsMenuPageHeader from "../OptionsMenuPageHeader";
import { connect } from "react-redux";
import $ from "jquery";
import LoaderComponent from "../LoaderComponent";
import { getAboutUsPageContent } from "../../actions";

//=============================================================================
// Class AboutUsPage
//=============================================================================
class AboutUsPage extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      pageContent: "",
    };
  }

  //---------------------------------------------------------------------------
  componentDidMount() {
    this.props
      .getAboutUsPageContent()
      .then((res) => {
        if (res.html) {
          this.setState({
            pageContent: res.html,
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    this.resetHeaderPosition();
    this.interval = setInterval(() => {
      this.resetHeaderPosition();
    }, 10);
    setTimeout(() => {
      clearInterval(this.interval);
    }, 20000);

    window.addEventListener("resize", this.resetHeaderPosition);
  }

  //---------------------------------------------------------------------------
  componentWillUnmount() {
    window.removeEventListener("resize", this.resetHeaderPosition);
    clearInterval(this.interval);
  }

  //---------------------------------------------------------------------------
  resetHeaderPosition = () => {
    if ($(".menu-header-container")) {
      let headerHeight = $(".menu-header-container").outerHeight();
      $(".page-content").css("padding-top", headerHeight + 10 + "px");
    }
  };

  //---------------------------------------------------------------------------
  createMarkup = () => {
    return { __html: this.state.pageContent };
  };

  //---------------------------------------------------------------------------
  // Main Render Function
  //---------------------------------------------------------------------------
  render() {
    const { isLoading } = this.state;
    return isLoading ? (
      <LoaderComponent loading={isLoading} />
    ) : (
      <div className="about-us-page-container">
        <OptionsMenuPageHeader
          goBack={() => {
            this.props.history.push("/");
          }}
          headerTitle="About Us"
          showHome={true}
        />
        <div className="page-content">
          <div
            className="data-container"
            dangerouslySetInnerHTML={this.createMarkup()}
          />
          ;
        </div>
      </div>
    );
  }
}

//-----------------------------------------------------------------------------
export default connect(null, { getAboutUsPageContent })(AboutUsPage);
